import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'GRUPO_FATURAMENTO_RADIOLOGISTA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'GRUPO_FATURAMENTO_RADIOLOGISTA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('grupoFaturamentoRadiologistaForm', registro)
    ];
}

export function getLista(id_grupo_faturamento) {
	const request = axios.get(`${consts.API_URL}/grupoFaturamentoRadiologista?id_grupo_faturamento=${id_grupo_faturamento}`);
	return {
		type: 'GRUPO_FATURAMENTO_RADIOLOGISTA_LISTADO',
		payload: request
	};
}

export function salvar(registro, evento) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/grupoFaturamentoRadiologista`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_grupo_faturamento));
				dispatch(setModoTela('lista'));
				
				try {
					if (evento) {
						evento();
					}
				} catch(ex) {

				}
				
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/grupoFaturamentoRadiologista`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_grupo_faturamento));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/grupoFaturamentoRadiologista?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(registro.id_grupo_faturamento));
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}